// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"24a93158","534":"9f742277","769":"2c9037c1","807":"409b6a7e"}[chunkId] + ".chunk.js";
};